import { useState } from "react";
import { Form, Offcanvas } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { DashSquareFill, PlusSquareFill } from "react-bootstrap-icons";

interface MembershipIESAProps {
    show: boolean;
    handleClose: () => void;
    data?: any;
}


const MembershipIESA = ({ show, handleClose, data }: MembershipIESAProps) => {
    const [iesaAdvantage, setIesaAdvantage] = useState<any[]>([""]);
    const [isLoading, setLoading] = useState(false);

    const onSubmit = () => {

    }

    return (
        <>
            <Offcanvas show={show} onHide={() => {
                handleClose();
            }}
                placement="end"
                className="offcanvas-custom">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>IESA Advantage</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>IESA Advantage</Form.Label>
                            {iesaAdvantage.map((item, index) => (
                                <div className="d-flex align-items-start mb-2" key={index}>
                                    <Form.Control
                                        type="text"
                                        placeholder="Title"
                                        value={item}
                                        onChange={(e) => {
                                            const newArray = [...iesaAdvantage];
                                            newArray[index] = e.target.value;
                                            setIesaAdvantage(newArray);
                                        }}
                                    />
                                    <div className="d-flex mt-2">
                                        <PlusSquareFill
                                            onClick={() => {
                                                setIesaAdvantage([...iesaAdvantage, ""]);
                                            }}
                                            className="ms-2 me-2 cursor-pointer"
                                        />
                                        {iesaAdvantage.length > 1 && <DashSquareFill
                                            onClick={() => {
                                                const newArray = iesaAdvantage.filter((_, i) => i !== index);
                                                setIesaAdvantage(newArray);
                                            }}
                                            className="cursor-pointer"
                                        />}
                                    </div>
                                </div>
                            ))}
                        </Form.Group>
                    </Form>
                </Offcanvas.Body>
                <div className="d-flex justify-content-end p-3">
                    <CustomButton
                        isLoading={isLoading}
                        label="Save"
                        className="w-100"
                        onClick={onSubmit}
                    />
                </div>
            </Offcanvas>
        </>
    )
}

export default MembershipIESA;